import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Box, Typography } from "@material-ui/core";

import { Spinner } from "../icons";
import palette from "../styles/palette";

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  text: {
    paddingTop: "1.25rem",
    fontSize: "0.875rem",
    color: palette.typography.black.inactive,
    fontWeight: 500,
    letterSpacing: "-0.02em",
  },
}));

export const SpinnerWithText = ({ text }) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Spinner />
      {text && <Typography className={classes.text}>{text}</Typography>}
    </Box>
  );
};

export default SpinnerWithText;
